<template>
  <div v-if="localShow" class="modal-overlay" @click="closeModal">
    <div class="modal-dialog" @click.stop>
      <BaseDialog
        :title="'Add Profiling Session'"
        :footerButtons="['Cancel', 'Create']"
        @cancel="closeModal"
        @create="createProfile"
      >
        <div class="form-grid">
          <div class="form-group">
            <label for="profiler-session-name" class="required">Name</label>
            <input
              id="profiler-session-name"
              v-model="sessionName"
              type="text"
              class="select"
              placeholder="Enter session name"
            >
          </div>

          <div class="form-group">
            <label for="profiler-session-description">Description</label>
            <textarea
              id="profiler-session-description"
              v-model="sessionDescription"
              class="select"
              rows="4"
              placeholder="Enter session description"
            ></textarea>
          </div>
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import BaseDialog from '@/components/DilaogTemplate/BaseDialog.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const emit = defineEmits(['profile-created']);

const localShow = ref(false);
const sessionName = ref('');
const sessionDescription = ref('');
const $toast = useToast();
const dataConnect = new DatastoreConnect();

function showModal() {
  localShow.value = true;
}

function closeModal() {
  localShow.value = false;
  sessionName.value = '';
  sessionDescription.value = '';
}

async function createProfile() {
  if (!sessionName.value || !sessionName.value.trim()) {
    $toast.open({
      queue: true,
      duration: 5000,
      message: 'Missing profile session name',
      type: 'error',
      position: 'top',
    });
    return;
  }

  try {
    const response = await dataConnect.api('profile.add', {
      name: sessionName.value.trim(),
      description: sessionDescription.value || '',
    });

    if (response?.error) {
      $toast.open({
        queue: true,
        duration: 5000,
        message: response.error.message || 'Failed to create profiling session',
        type: 'error',
        position: 'top',
      });
      return;
    }

    emit('profile-created', response?.result || null);
    closeModal();
  } catch (error) {
    $toast.open({
      queue: true,
      duration: 5000,
      message: String(error || 'Failed to create profiling session'),
      type: 'error',
      position: 'top',
    });
  }
}

defineExpose({
  showModal,
  createProfile,
});
</script>

<style lang="scss" scoped>

.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.modal-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

